import React from 'react'
import {FaGem} from 'react-icons/fa'
import { brdcrmbs } from './mock'

export const Breadcrumbs = () => {
    return(
        <div className="breadcrumbs">
            <ul>
                {
                    brdcrmbs.map((item,i)=>{
                        return (
                            <li key={'breadcrumbs'+i}>
                               <div>
                                   <a href={item.url}>
                                        <div>{item.symbol}</div>
                                        <div>{item.title}</div>
                                   </a>
                               </div>
                            </li>
                        )
                    })
                }
            </ul>
            <a href="/projects/create">
                <div className="button" title="Günde en fazla bir sefer proje açabilirsinizs">
                    <FaGem /> <p> Premium </p> {/** Premium dene**/}
                </div>
            </a>
        </div>
    )



}
 